export const TFAuthenticationLoginModal: string = 'TFAuthenticationLoginModal';
